<template>
    <div>
        <div class="flex justify-between items-center mb-6">
            <div class="flex cursor-pointer text-green-600 hover:text-green-700" @click="goBack">
                <i class='bx bx-left-arrow-alt bx-sm my-auto'></i>
                <p class="text-xl font-semibold d-none d-md-block">Chỉnh sửa tin tuyển dụng</p>
            </div>
            <div class="flex gap-1">
                <button @click="getEntry" class="admin-refresh-btn">
                    <i class='bx bx-refresh my-auto' ></i><p>Đặt lại</p>
                </button>
                <button @click="saveAction" class="admin-save-btn">
                    <i class='bx bx-save text-white my-auto' ></i><p>Lưu</p>
                </button>
            </div>
        </div>
        <div class="entry-detail grid grid-cols-1 lg:grid-cols-2 gap-4">
            <entryName class="lg:col-span-2" v-model="entry" @update="(e) => (entry = e)" />
            <entryPosition v-model="entry" @update="(e) => (entry = e)" />
            <entryQuantity v-model="entry" @update="(e) => (entry = e)" />
            <entryDescription class="lg:col-span-2" v-model="entry" @update="(e) => (entry = e)" />
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import entryName from './partials/entry-name.vue';
import entryPosition from './partials/entry-position.vue';
import entryQuantity from './partials/entry-quantity.vue';
import entryDescription from './partials/entry-description.vue';
export default {
    name: 'edit',
    components: {
        entryDescription, entryName, entryPosition, entryQuantity
    },
    data() {
        return {
            entry: {
                name: '',
                description: '',
                position: '',
                quantity: ''
            }
        }
    },
    methods: {
        ...mapActions('recruitment', ['GetRecruitment', 'UpdateRecruitment']),
        saveAction() {
            let validate = {
                name: 'Tên đơn vị',
                position: 'Vị trí',
                quantity: 'Số lượng',
                description: 'Mô tả',
            };
            if (!this.$validator(this.entry, validate)) return
            this.$swal.fire({
            title: 'Sửa chi tiết tin tuyển dụng?',
            text: "",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sửa!',
            cancelButtonText: 'Hủy'
            }).then(async (result) => {
                if (result.isConfirmed) {
                    await this.UpdateRecruitment(this.entry);
                    this.goBack()
                }
            })
        },
        goBack() {
            this.$router.push({
				name: "admin." + this.$route.name.split(".")[1],
			});
        },
        async getEntry() {
            let response = await this.GetRecruitment(this.$route.params.id)
            this.entry = response.data
        }
    },
    created() {
        this.getEntry()
    }
}
</script>
<style>
.entry-detail .form-group {
    margin-bottom: 0;
}
</style>